module.exports = __CONFIG__;